<template>
    <main id="home-wrapper">
        <div>
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    {
                        title: 'Payment Gateway',
                        url: app_url + '/event',
                        status: true
                    }
                ]"
            ></breadcrumb>
            <section id="headline-events" class="section withPad blackBg">
                <div class="container">
                    <div class="wrapper-popup">
                        <div class="card-popup">
                            <form
                                @submit.prevent="onSubmitPayment"
                                class="card-body"
                            >
                                <h4>
                                    Pembayaran Honda Bikers Day Nasional 2024
                                </h4>
                                <p>
                                    Lakukan pembayaran untuk pembelian eksklusif
                                    Starter Kit Honda Bikers Day 2024
                                </p>
                                <div class="display-product">
                                    <div class="product-info">
                                        <h5 class="title">
                                            Starter Kit Honda Bikers Day 2024
                                        </h5>
                                        <h4 class="price">Rp 20.000</h4>
                                    </div>
                                </div>
                                <div class="payment-methods">
                                    <h4>Pilih Metode Pembayaran</h4>
                                    <div class="list-payment">
                                        <!-- Ewallet -->
                                        <div class="wrapper-va">
                                            <div class="radio-container">
                                                <input
                                                    v-model="form.payment_type"
                                                    type="radio"
                                                    id="ewallet"
                                                    name="payment_type"
                                                    value="ewallet"
                                                />
                                                <label
                                                    class="radio-custom"
                                                    for="ewallet"
                                                ></label>
                                                <span class="radio-label">
                                                    <img
                                                        :src="
                                                            base_url +
                                                                '/images/payment/wallet-icon.png'
                                                        "
                                                        alt="icon-ewallet"
                                                    />
                                                    E-Wallet
                                                </span>
                                            </div>
                                            <div
                                                class="list-items-va"
                                                v-show="
                                                    form.payment_type ===
                                                        'ewallet'
                                                "
                                            >
                                                <div
                                                    v-if="loaderEwallet"
                                                    class="loading loading-double"
                                                ></div>
                                                <a
                                                    v-else
                                                    v-for="(ewallet,
                                                    index) in eWallets"
                                                    :key="index"
                                                    @click="
                                                        changePaymentProvider(
                                                            ewallet.code
                                                        )
                                                    "
                                                    class="item-link"
                                                    :class="{
                                                        active:
                                                            form.payment_provider ===
                                                            ewallet.code
                                                    }"
                                                >
                                                    <img
                                                        :src="
                                                            `https://static.xendit.co/logos/new-logos/${ewallet.image}`
                                                        "
                                                        :alt="ewallet.name"
                                                    />
                                                    {{ ewallet.name }}
                                                </a>
                                            </div>
                                        </div>

                                        <!-- Virtual Account -->
                                        <div class="wrapper-va">
                                            <div class="radio-container">
                                                <input
                                                    v-model="form.payment_type"
                                                    type="radio"
                                                    id="virtual_account"
                                                    name="payment"
                                                    value="virtual_account"
                                                />
                                                <label
                                                    class="radio-custom"
                                                    for="virtual_account"
                                                ></label>
                                                <span class="radio-label">
                                                    <img
                                                        :src="
                                                            base_url +
                                                                '/images/payment/transfer.png'
                                                        "
                                                        alt="icon-va"
                                                    />
                                                    Virtual Account Transfer
                                                </span>
                                            </div>
                                            <div
                                                class="list-items-va"
                                                v-show="
                                                    form.payment_type ===
                                                        'virtual_account'
                                                "
                                            >
                                                <div
                                                    v-if="loaderVa"
                                                    class="loading loading-double"
                                                ></div>
                                                <a
                                                    v-else
                                                    v-for="(vAccount,
                                                    index) in virtualAccounts"
                                                    :key="index"
                                                    @click="
                                                        changePaymentProvider(
                                                            vAccount.code
                                                        )
                                                    "
                                                    class="item-link"
                                                    :class="{
                                                        active:
                                                            form.payment_provider ===
                                                            vAccount.code
                                                    }"
                                                >
                                                    <img
                                                        :src="
                                                            `https://static.xendit.co/logos/new-logos/${vAccount.code.toLowerCase()}-logo.svg`
                                                        "
                                                        :alt="vAccount.code"
                                                    />
                                                    {{ vAccount.name }}
                                                </a>
                                            </div>
                                        </div>

                                        <!-- Retail Outlet -->
                                        <div class="wrapper-va">
                                            <div class="radio-container">
                                                <input
                                                    v-model="form.payment_type"
                                                    type="radio"
                                                    id="retail_outlet"
                                                    name="payment"
                                                    value="retail_outlet"
                                                />
                                                <label
                                                    class="radio-custom"
                                                    for="retail_outlet"
                                                ></label>
                                                <span class="radio-label">
                                                    <img
                                                        :src="
                                                            base_url +
                                                                '/images/payment/retail-outlet-icon.png'
                                                        "
                                                        alt="icon-retail-outlet"
                                                    />
                                                    Retail Outlet
                                                </span>
                                            </div>
                                            <div
                                                class="list-items-va"
                                                v-show="
                                                    form.payment_type ===
                                                        'retail_outlet'
                                                "
                                            >
                                                <div
                                                    v-if="loaderVa"
                                                    class="loading loading-double"
                                                ></div>
                                                <a
                                                    v-else
                                                    v-for="(outlet,
                                                    index) in retailOutlets"
                                                    :key="index"
                                                    @click="
                                                        changePaymentProvider(
                                                            outlet.code
                                                        )
                                                    "
                                                    class="item-link"
                                                    :class="{
                                                        active:
                                                            form.payment_provider ===
                                                            outlet.code
                                                    }"
                                                >
                                                    <img
                                                        :src="
                                                            `https://static.xendit.co/logos/new-logos/${outlet.code.toLowerCase()}-logo.svg`
                                                        "
                                                        :alt="outlet.code"
                                                    />
                                                    {{ outlet.name }}
                                                </a>
                                            </div>
                                        </div>

                                        <!-- QRIS -->
                                        <div class="radio-container">
                                            <input
                                                v-model="form.payment_type"
                                                type="radio"
                                                id="qris"
                                                name="payment"
                                                value="qris"
                                            />
                                            <label
                                                class="radio-custom"
                                                for="qris"
                                            ></label>
                                            <span class="radio-label">
                                                <img
                                                    :src="
                                                        base_url +
                                                            '/images/payment/qris-icon.png'
                                                    "
                                                    alt="icon-qris"
                                                />
                                                QRIS
                                            </span>
                                        </div>

                                        <!-- COD -->
                                        <div v-if="!changePaymentOnline" class="radio-container">
                                            <input
                                                v-model="form.payment_type"
                                                type="radio"
                                                id="cod"
                                                name="payment"
                                                value="cod"
                                            />
                                            <label
                                                class="radio-custom"
                                                for="cod"
                                            ></label>
                                            <span class="radio-label">
                                                <img
                                                    :src="
                                                        base_url +
                                                            '/images/payment/cod-icon.png'
                                                    "
                                                    alt="icon-cod"
                                                />
                                                Bayar di tempat
                                            </span>
                                        </div>
                                    </div>
                                    <span
                                        class="help-block"
                                        v-if="form.errors.has('payment_type')"
                                        v-text="form.errors.get('payment_type')"
                                    >
                                    </span>
                                </div>
                                <div class="message-join" v-if="message">
                                    {{ message }}
                                </div>
                                <div class="button">
                                    <div
                                        v-if="loader"
                                        class="loading loading-double"
                                    ></div>
                                    <div v-else class="wrapper-button-action">
                                        <a
                                            v-if="!changePaymentOnline"
                                            @click="trackerClickBack()"
                                            class="btn"
                                            >Kembali</a
                                        >
                                        <button
                                            type="submit"
                                            class="btn btn-red mr-auto"
                                        >
                                            Selanjutnya
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>
<script>
import BreadCrumb from "../../widget/BreadCrumb";
import { encrypt, decrypt } from "../../../lib/crypto";
export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            cdn_url: cdn_url,
            loader: false,
            base_url: base_url,
            app_url: app_url,
            api_url: "",
            event: {},
            event_attend: {},
            user: {},
            transaction: {},
            isShowVa: false,
            loaderVa: false,
            loaderEwallet: false,
            loaderRetailOutlet: false,
            virtualAccounts: [],
            eWallets: [],
            retailOutlets: [],
            changePaymentOnline: false,
            form: new Form({
                _token: token,
                change_payment: false,
                event_id: "",
                event_attend_id: "",
                payment_type: "",
                payment_provider: ""
            }),
            formAttend: new Form({
                _token: token,
                event_id: "",
                category_motor: "",
                variant_motor: "",
                police_number: ""
            }),
            message: ""
        };
    },
    created() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.message = "";
        this.checkUserSimulate();
        this.getVirtualAccounts();
        this.getEwallets();
        this.getRetailOutlets();
        this.checkchangePayment();

        const updatePoliceNumber = localStorage.getItem("update-police-number");
        const event = localStorage.getItem("event-hbd");
        const getAccountNumber = localStorage.getItem("account_number");
        const changePayment = localStorage.getItem("change-payment");
        // const paymentEvent = localStorage.getItem("payment-event");
        // if (paymentEvent) {
        //     window.location.href = `/community/hcid`;
        // }
        if (this.changePaymentOnline) {
            // console.log("masuk dssdf");
            this.checkEventAttendUser(JSON.parse(event));
        }
        if (getAccountNumber) {
            this.account_number = getAccountNumber;
        }
        if (!event) {
            window.location.href = `${this.event.detail_url_web}`;
        } else {
            this.event = JSON.parse(event);
            // this.handleGetDataEventAttendLocalStorage();
        }
        if (!updatePoliceNumber) {
            window.location.href = `${this.event.detail_url_web}/verification-police-number`;
        }
    },
    methods: {
        checkchangePayment() {
            const params = new URLSearchParams(window.location.search);
            if (params.get("change-payment")) {
                // console.log("masuk");
                this.form.change_payment = true;
                this.changePaymentOnline = true;
            }
        },
        checkUserSimulate() {
            const checkHcid = process.env.MIX_HCID_PAYMENT_TEST.split(",");
            const user = this.user.hcid;
            if (checkHcid.includes(user.toString())) {
                this.isShowVa = true;
            } else {
                this.isShowVa = false;
            }
        },
        copyClipboard() {
            navigator.clipboard.writeText(this.account_number);
            this.copy_text = "Copied!";
            setTimeout(() => {
                this.copy_text = "Copy code";
            }, 3000);
        },
        changePaymentProvider(item) {
            if (this.form.payment_provider === item) {
                this.form.payment_provider = "";
            } else {
                this.form.payment_provider = item;
            }
        },
        async getVirtualAccounts() {
            this.loaderVa = true;
            await axios
                .get(`${api_url}/member/event/get-all-virtual-account`)
                .then(response => {
                    let activeVa = response.data.data.filter(
                        item => item.is_activated === true
                    );
                    this.virtualAccounts = activeVa;
                    this.loaderVa = false;
                })
                .catch(error => {
                    console.log(error, "error");
                });
        },
        async getEwallets() {
            this.loaderEwallet = true;
            await axios
                .get(`${api_url}/member/event/get-all-ewallet`)
                .then(response => {
                    this.eWallets = response.data.data;
                    this.loaderEwallet = false;
                })
                .catch(error => {
                    console.log(error, "error");
                });
        },
        async getRetailOutlets() {
            this.loaderRetailOutlet = true;
            await axios
                .get(`${api_url}/member/event/get-all-retail-outlet`)
                .then(response => {
                    this.retailOutlets = response.data.data;
                    this.loaderRetailOutlet = false;
                })
                .catch(error => {
                    this.loaderRetailOutlet = false;
                    console.log(error, "error");
                });
        },
        async onSubmitPayment() {
            this.loader = true;
            this.form.event_id = this.event.id;
            this.handleGetDataEventAttendLocalStorage();
            await this.form
                .post(`${api_url}/member/event/payment`)
                .then(async response => {
                    if (response.status) {
                        const dataVaEncrypt = await this.handleEncrypt(
                            JSON.stringify(response.data)
                        );
                        localStorage.setItem("transaction-hbd", dataVaEncrypt);
                        this.transaction = response.data;
                        localStorage.setItem("payment-event", true);
                        this.onSubmitJoinEvent();
                    } else {
                        if (response.message == "PAYMENT_HAS_GENERATED") {
                            this.message =
                                "Mohon untuk selesaikan pembayaranmu yang sebelumnya.";

                            setTimeout(() => {
                                this.loader = false;
                                const paymentData = response.data;
                                this.checkRedirect(paymentData);
                            }, 3500);
                        } else {
                            this.loader = false;
                        }
                    }
                })
                .catch(error => {
                    console.log(error, "error");
                    this.loader = false;
                });
        },
        async onSubmitJoinEvent() {
            await this.formAttend
                .post(`${api_url}/member/event/join-hbd`)
                .then(response => {
                    if (response.status) {
                        this.event_attend = response.data.event_attend;
                        this.trackerClickPayment(this.transaction);
                        if (this.changePaymentOnline) {
                            localStorage.setItem(
                                "payment-confirmation-popup",
                                "close"
                            );
                        }
                        this.checkRedirect(this.transaction);
                    }
                    if (response.status_code == "HCID_NOT_GENERATED") {
                        this.redirectUserHcid(response);
                    }
                    this.loader = false;
                })
                .catch(error => {
                    console.log(error);
                    this.loader = false;
                });
        },
        checkRedirect(payment) {
            switch (payment.payment_type) {
                case "virtual_account":
                    window.location.href = `${this.event.detail_url_web}/payment/virtual-account`;
                    break;
                case "ewallet":
                    let redirectLink = null;
                    let actionLink = payment.payment_detail.actions;
                    if (actionLink.mobile_deeplink_checkout_url)
                        redirectLink = actionLink.desktop_web_checkout_url;
                    else if (actionLink.mobile_web_checkout_url)
                        redirectLink = actionLink.mobile_web_checkout_url;
                    else redirectLink = actionLink.desktop_web_checkout_url;
                    window.location.href = redirectLink;
                    break;
                case "qris":
                    window.location.href = `${this.event.detail_url_web}/payment/qris`;
                    break;
                case "retail_outlet":
                    window.location.href = `${this.event.detail_url_web}/payment/retail-outlet`;
                    break;
                default:
                    window.location.href = `${this.event.detail_url_web}/thank-you`;
                    break;
            }
        },
        async checkEventAttendUser(event) {
            await axios
                .get(`${api_url}/member/event/${event.id}/get-event-attend`)
                .then(response => {
                    if (response.status) {
                        const eventAttend = response.data.data.event_attend;
                        this.event_attend = eventAttend;
                        this.formAttend.event_attend_id = eventAttend._id;
                        this.formAttend.event_id = eventAttend.event_id;
                        this.formAttend.category_motor = JSON.stringify(
                            eventAttend.category_motor
                        );
                        this.formAttend.variant_motor = JSON.stringify(
                            eventAttend.variant_motor
                        );
                        this.formAttend.police_number =
                            eventAttend.police_number;

                        console.log(this.formAttend, "formAttend");
                    }
                })
                .catch(error => {
                    this.loader = false;
                    console.log(error, "error");
                });
        },
        async handleEncrypt(input) {
            try {
                const encryptText = await encrypt(
                    input,
                    process.env.MIX_ENCODED_SECRET_KEY
                );
                return encryptText;
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        async handleDecrypt(input) {
            try {
                return await decrypt(input, process.env.MIX_ENCODED_SECRET_KEY);
            } catch (error) {
                window.location.href = `${this.event.detail_url_web}/verification-police-number`;
                return false;
            }
        },
        async handleGetDataEventAttendLocalStorage() {
            const eventAttendEncrypt = localStorage.getItem("event-attend-hbd");
            if (eventAttendEncrypt) {
                await this.handleDecrypt(eventAttendEncrypt).then(data => {
                    const eventAttend = JSON.parse(data);
                    // console.log(data);
                    this.event_attend = eventAttend;
                    this.formAttend.event_attend_id = eventAttend.id;
                    this.formAttend.event_id = eventAttend.event_id;
                    this.formAttend.category_motor = JSON.stringify(
                        eventAttend.category_motor
                    );
                    this.formAttend.variant_motor = JSON.stringify(
                        eventAttend.variant_motor
                    );
                    this.formAttend.police_number = eventAttend.police_number;
                });
            }
        },
        redirectUserHcid(response) {
            this.message = response.message;
            this.loader = false;
            setTimeout(() => {
                window.location.href = "/community/hcid";
            }, 3500);
        },
        trackerClickBack() {
            const event = this.event;
            let data = {
                event: "paymentEvent",
                "eventDetail.category": "Join Event Community",
                "eventDetail.action": `Payment Gateway - Kembali`,
                eventName: event.name, //Event Name
                id: event.id, //Event ID
                eventType: event.type, //Event Type
                startDate: event.start_date, //Event Start Date
                endDate: event.end_date, //Event End Date
                publishedDate: event.created_at, //Event Created Date
                motorCategory: this.event_attend.category_motor.name, //Selected Motor category
                motorVariant: this.event_attend.variant_motor.name, //Selected Motor Variant
                paymentOption: this.form.payment_provider
                    ? `${this.form.payment_type} - ${this.form.payment_provider}`
                    : this.form.payment_type,
                province: event.province //Event Province
            };
            dataLayer.push(data);
            window.location.href = `${this.event.detail_url_web}/verification-police-number`;
        },
        trackerClickPayment(transaction) {
            const event = this.event;
            let data = {
                event: "paymentEvent",
                "eventDetail.category": "Join Event Community",
                "eventDetail.action": `Payment Gateway - Selanjutnya`,
                eventName: event.name, //Event Name
                id: event.id, //Event ID
                eventType: event.type, //Event Type
                startDate: event.start_date, //Event Start Date
                endDate: event.end_date, //Event End Date
                publishedDate: event.created_at, //Event Created Date
                motorCategory: this.event_attend.category_motor.name, //Selected Motor category
                motorVariant: this.event_attend.variant_motor.name, //Selected Motor Variant
                paymentOption: transaction.payment_provider
                    ? `${transaction.payment_type} - ${transaction.payment_provider}`
                    : transaction.payment_type,
                province: event.province, //Event Province
                transactionId: transaction.external_id //Transaction id generate by backend
            };
            dataLayer.push(data);
        }
    }
};
</script>
<style scoped lang="scss">
.message-join {
    position: relative;
    margin: 13px 0;
    padding-bottom: 13px;
    text-align: center;
    color: #e61c33;
    font-weight: 500;
    font-size: 15px;
}

label {
    margin-bottom: 0 !important;
}

.wrapper-popup {
    position: relative;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        // padding: 10px;
        width: 558px;
        overflow: hidden;

        @media screen and (max-width: 787px) {
            width: 100%;
        }

        .wrapper-va {
            position: relative;

            .inner-va-information {
                color: #000;
                background-color: #eaeaea;
                padding: 15px 25px;

                h5 {
                    font-size: 20px;
                    font-weight: 700;
                }

                p {
                    font-size: 15px;
                    font-weight: 300;
                    color: #000;

                    .va-total,
                    .va-timeout {
                        font-weight: 700;
                    }

                    .va-timeout {
                        color: #e61b33;
                    }
                }
            }

            .inner-va-number {
                padding: 20px 25px;
                margin-bottom: 15px;

                p {
                    color: #000;
                    font-size: 16px;
                }

                .va-number {
                    padding: 30px;
                    color: #000;
                    background-color: #eaeaea;
                    border-radius: 10px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .va-copy {
                        a {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 10px;
                            border-radius: 10px;
                            gap: 10px;

                            &:hover {
                                padding: 10px;
                                background-color: #000;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            color: rgba(40, 40, 40, 1);
            height: 100%;

            p {
                font-size: 15px;
                width: 400px;
                color: rgba(63, 63, 63, 1);

                @media screen and (max-width: 787px) {
                    width: 100%;
                }
            }

            .display-product {
                position: relative;
                display: flex;
                gap: 15px;
                padding-bottom: 2rem;

                .product-info {
                    padding-top: 10px;

                    .title {
                        font-size: 18px;
                        font-weight: 700;
                    }

                    .price {
                        font-size: 18px;
                        font-weight: 700;
                        color: rgba(230, 27, 51, 1);
                    }
                }
            }

            .payment-methods {
                padding-bottom: 2rem;

                .radio-container {
                    display: flex;
                    align-items: center;
                    flex-direction: row-reverse;
                    width: 100%;
                    justify-content: space-between;
                    border: 1px solid rgba(216, 216, 216, 1);
                    border-right: none;
                    border-left: none;
                    border-top: none;
                    font-size: 16px;
                    padding: 13px 0;
                    font-weight: 600;

                    .radio-label {
                        img {
                            margin-right: 10px;
                        }
                    }
                }

                .radio-container input[type="radio"] {
                    display: none;
                }

                .radio-custom {
                    width: 20px;
                    height: 20px;
                    border: 2px solid red;
                    border-radius: 50%;
                    display: inline-block;
                    position: relative;
                    cursor: pointer;
                }

                .radio-custom::after {
                    content: "";
                    width: 10px;
                    height: 10px;
                    background-color: red;
                    border-radius: 50%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: none;
                }

                input[type="radio"]:checked + .radio-custom::after {
                    display: block;
                }

                .list-items-va {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    padding-top: 10px;
                    padding-left: 55px;
                    border-radius: 5px;
                    font-size: 14px;
                    font-weight: 600;

                    .item-link {
                        border: 1px solid #d8d8d8;
                        padding: 8px;
                        border-radius: 6px;
                        font-size: 14px;
                        font-weight: 600;
                        cursor: pointer;
                        color: #000;
                        text-decoration: none;

                        img {
                            width: 35px;
                            margin-right: 10px;
                        }
                    }

                    .active {
                        border-color: #e61b33;
                    }
                }
            }

            .wrapper-button-action {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 20px;
            }

            .btn {
                width: 100%;
                max-width: 100%;
                font-weight: 700;
                font-size: 14px;
                padding: 0;
                height: 42px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                    background-color: #333 !important;
                    color: #fff;
                }
            }

            .red-button {
                width: 100%;
                background-color: #e61b33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
}
</style>
